var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M18.75 18.906C8.775 18.906 5.094 9.802 4.5 5.25h4.75l1.188 3.563L8.062 10c.95 2.85 3.959 5.146 5.344 5.938l1.781-1.782 3.563.594z"
})));
export { SvgPhoneOutline as ReactComponent };
export default "/_next/static/images/phone-outline.svg";